import { useMemo } from 'react'
import { Column } from 'react-table'
import { useTranslation } from 'react-i18next'

import SelectionTable, { SelectionTableProps } from '@/components/ui/tables/SelectionTable'

export type DoctorData = {
  id: string
  cps: string
  name: string
  surname: string
  email: string
  stripeActivated: boolean
}

export type DoctorSelectionTableProps = Pick<SelectionTableProps<DoctorData>, 'data' | 'onSelect' | 'readOnly' | 'selected'>

export function DoctorSelectionTable(props: DoctorSelectionTableProps) {
  const { t } = useTranslation()

  const columns = useMemo(() => {
    return [
      {
        Header: t('field.name.label'),
        accessor: 'name',
        width: 'unset',
      },
      {
        Header: t('field.lastName.label'),
        accessor: 'surname',
        width: 'unset',
      },
      {
        Header: t('field.cps.label'),
        accessor: 'cps',
        width: 'unset',
      },
      {
        Header: t('field.email.label'),
        accessor: 'email',
        width: 'unset',
      }
    ] as Column<DoctorData>[]
  }, [t])

  return <SelectionTable {...props} columns={columns} />
}

export default DoctorSelectionTable
